import React, { useState } from "react";
import "./LoginRegister.css";

const Register = () => {
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    password2: "",
  });

  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const { password, password2 } = formData;

    // Passwort-Regeln
    const passwordRegex =
      /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*.-])[A-Za-z\d!@#$%^&*.-]{8,}$/;

    if (!passwordRegex.test(password)) {
      setError(
        "Das Passwort muss mindestens 8 Zeichen lang sein, einen Großbuchstaben, eine Zahl und ein Sonderzeichen enthalten."
      );
      setSuccessMessage("");
      return;
    }

    if (password !== password2) {
      setError("Die Passwörter stimmen nicht überein.");
      setSuccessMessage("");
      return;
    }

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/auth/register`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );

      const result = await response.json();

      if (response.ok) {
        setSuccessMessage(
          "Registrierung erfolgreich! Bitte überprüfe deine E-Mails zur Bestätigung."
        );
        setError("");
        setFormData({ email: "", password: "", password2: "" });
      } else {
        setError(result.message || "Fehler bei der Registrierung.");
        setSuccessMessage("");
      }
    } catch (err) {
      setError("Es gab einen Fehler bei der Registrierung.");
      setSuccessMessage("");
    }
  };

  return (
    <div className="register-container-user">
      <h2 className="register-header">Registrierung</h2>

      {successMessage && <p className="success-message">{successMessage}</p>}
      {error && <p className="error-message">{error}</p>}

      <form className="register-form" onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="email">E-Mail</label>
          <input
            type="email"
            id="email"
            name="email"
            className="form-input"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="password">Passwort</label>
          <input
            type="password"
            id="password"
            name="password"
            className="form-input"
            value={formData.password}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="password2">Passwort wiederholen</label>
          <input
            type="password"
            id="password2"
            name="password2"
            className="form-input"
            value={formData.password2}
            onChange={handleChange}
            required
          />
        </div>

        <button type="submit" className="register-button">
          Registrieren
        </button>
      </form>
    </div>
  );
};

export default Register;
